export default __webpack_public_path__ + "static/media/Tek_FAQs_video_v2.080f6055.mp4";